import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Brain, Warning, TrendUp, CheckCircle, XCircle, Gear } from "@phosphor-icons/react";

export default function AdminAI() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/ai/suggestions");
      setData(data);
    } catch (e) {
      toast.error("Erro ao carregar sugestoes");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-ai-page">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Inteligencia interna</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">IA do Banco</h1>
        </div>
        <button className="brand" onClick={load} disabled={loading} data-testid="refresh-ai-btn">{loading ? "Analisando..." : "Atualizar"}</button>
      </div>

      {data?.ai_status === "active" && (
        <div className="border border-[#7B9D7E] bg-[#EAF1EA] p-3 mb-6 text-sm flex items-center gap-2 flex-wrap" data-testid="ai-status-active">
          <CheckCircle size={18} weight="fill" color="#5E7B60" />
          <span><strong>IA ativa.</strong> Insights gerados via OpenAI.</span>
          <span className="text-xs text-[#5C5A57]">Modelo: <code className="tabular">{data.ai_model}</code></span>
        </div>
      )}

      {data?.ai_status === "invalid" && (
        <div className="border border-[#DDA7A5] bg-[#F4E6E5] p-4 mb-6 text-sm flex items-start gap-2" data-testid="ai-status-invalid">
          <XCircle size={18} weight="fill" color="#8B5E5E" className="shrink-0 mt-0.5" />
          <span>
            <strong>Chave OpenAI invalida.</strong> A IA esta usando regras deterministicas como fallback.
            Revise a chave em <Link to="/admin/configuracoes" className="underline font-medium">Configuracoes</Link> e teste a conexao.
          </span>
        </div>
      )}

      {data?.ai_status === "unconfigured" && (
        <div className="border border-[#EBE5DF] bg-[#F5F0EB] p-4 mb-6 text-sm flex items-start gap-2" data-testid="ai-status-unconfigured">
          <Gear size={18} weight="duotone" className="shrink-0 mt-0.5" />
          <span>
            A IA esta operando com regras deterministicas. Cadastre sua chave OpenAI em{" "}
            <Link to="/admin/configuracoes" className="underline font-medium">Configuracoes &gt; IA / OpenAI</Link>{" "}
            para habilitar insights inteligentes. Nao e necessario editar arquivos no servidor.
          </span>
        </div>
      )}

      {data?.ai_insight && (
        <div className="border border-[#0A0A0A] bg-[#0A0A0A] text-white p-6 mb-8">
          <div className="flex items-center gap-2 mb-3">
            <Brain size={20} weight="duotone" />
            <span className="text-[10px] tracking-[0.2em] uppercase">Insight GPT</span>
          </div>
          <div className="text-sm leading-relaxed whitespace-pre-wrap">{data.ai_insight}</div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {(data?.suggestions || []).map((s, i) => (
          <div key={i} className="border border-[#EBE5DF] bg-white p-6" data-testid={`ai-suggestion-${s.type}`}>
            <div className="flex items-center gap-2 mb-3">
              {s.type === "risk_alert" ? <Warning size={18} weight="duotone" color="#8B5E5E" /> : <TrendUp size={18} weight="duotone" color="#7B9D7E" />}
              <span className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">{s.type === "risk_alert" ? "Alerta de risco" : "Oportunidade"}</span>
            </div>
            <h3 className="font-display text-xl font-bold tracking-tight mb-2">{s.title}</h3>
            <p className="text-sm text-[#5C5A57]">{s.detail}</p>
          </div>
        ))}
        {data?.suggestions?.length === 0 && (
          <div className="text-sm text-[#5C5A57]">Sem sugestoes no momento. Cadastre clientes e registre vendas para gerar insights.</div>
        )}
      </div>
    </div>
  );
}
